<template>
  <g ref="group"> </g>
</template>

<script lang="ts" setup>
import * as d3 from 'd3'
import { ref, toRefs } from 'vue'
import { useComponent } from './useComponent'
import { Font } from '.'

export type TextProps = {
  text: string
  x: number
  y: number
  stroke?: string
  fill?: string
  font?: Partial<Font>
  strokeWidth?: number
  anchor?: 'start' | 'middle' | 'end'
  xLimits?: [number, number]
  yLimits?: [number, number]
}

const fontDefaults = () => ({
  size: 10,
  family: 'Inter',
  weight: 400,
  lineHeight: 12
})

const props = withDefaults(defineProps<TextProps>(), {
  stroke: 'none',
  fill: '#000',
  strokeWidth: 3,
  anchor: 'middle',
  xLimits: () => [0, 1],
  yLimits: () => [0, 1],
  font: () => ({
    size: 10,
    family: 'Inter',
    weight: 400,
    lineHeight: 12
  })
})

const { text, x, y, stroke, xLimits, yLimits, strokeWidth, fill, font, anchor } = toRefs(props)

const group = ref<SVGGElement | null>(null)

useComponent(group, ({ width, height, group }) => {
  if (!xLimits?.value || !yLimits?.value) return
  if (!x?.value || !y?.value) return
  const xScale = d3.scaleLinear().domain(xLimits?.value).range([0, width])
  const yScale = d3.scaleLinear().domain(yLimits?.value).range([0, height])

  const fontValue = {
    ...fontDefaults(),
    ...font.value
  }

  group
    .append('text')
    .attr('fill', fill?.value ?? 'none')
    .attr('stroke', stroke?.value ?? 'none')
    .attr('stroke-width', strokeWidth?.value ?? 3)
    .attr('x', xScale(x.value))
    .attr('y', yScale(y.value))
    .text(text?.value)
    .attr('font-size', `${fontValue.size}px`)
    .attr('font-family', fontValue.family)
    .attr('font-weight', fontValue.weight)
    .attr('line-height', `${fontValue.lineHeight}px`)
    .attr('text-anchor', anchor.value)
})
</script>
